document.addEventListener('DOMContentLoaded', function () {
  setupDeleteGhost();

  // Delete cookie to add favorite item once this page is reached
  if (document.cookie.indexOf('fav') > -1) {
    document.cookie = 'fav=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
});

function setupDeleteGhost() {
  document.querySelectorAll('.remove-ghost-button').forEach(function ($button) {
    $button.addEventListener('click', async function (e) {
      e.preventDefault();
      const productid = $button.getAttribute('data-product-id');

      // Remove the ghosts
      const $container = document.getElementById(
        `ghost-product-container-${productid}`
      );
      $container.remove();

      try {
        await fetch(
          `${window.getBaseUrl()}/accounts/remove-ghost/${productid}/`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: productid,
          }
        );
      } catch (err) {
        console.error(`Error while removing ghost product: ${err}`);
      }
    });
  });
}
